// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"d995467a","821":"43cf9bda"}[chunkId] + ".chunk.js";
};